import {
  WppIconButton,
  WppIconMore,
  WppListItem,
  WppMenuContext,
  WppTypography,
} from '@wppopen/components-library-react'
import clsx from 'clsx'
import type { WppIconBluetoothOn as WppIconButtonType } from '@wppopen/components-library/components'
import styles from './MenuListPopUp.module.scss'

interface MenuItem {
  label: string
  onClick: () => void
}
export type MenuItems = MenuItem[]
interface MenuListPopUpProps {
  menuItems: MenuItems
  className?: string
  theme?: 'transparent-border'
  isDisabled?: boolean
  buttonSize?: WppIconButtonType['size']
  isInitialising?: boolean
}

function MenuListPopUp({
  menuItems,
  className,
  isDisabled,
  theme,
  buttonSize = 'm',
  isInitialising,
}: MenuListPopUpProps) {
  const disabledCondition = menuItems.length === 0 || isDisabled
  // TODO: explore a way to hook into onclick logic to lazy load

  return (
    (!!menuItems.length || isInitialising) && (
      <WppMenuContext
        data-testid="menu-context"
        className={clsx(styles.actions_menu, className, {
          [styles.transparent_border]: theme === 'transparent-border',
        })}
      >
        <WppIconButton
          aria-label="settings"
          data-testid="menu-actions"
          size={buttonSize}
          slot="trigger-element"
          onClick={e => {
            e.stopPropagation()
            if (disabledCondition) return
          }}
          className={styles.action_button}
          disabled={disabledCondition}
        >
          <WppIconMore />
        </WppIconButton>

        <div className={styles.actions_container}>
          {menuItems.map(({ label, onClick }) => (
            <WppListItem key={label} onWppChangeListItem={onClick} data-testid="menu-action-option">
              <WppTypography tag="p" type="s-body" slot="label">
                {label}
              </WppTypography>
            </WppListItem>
          ))}
        </div>
      </WppMenuContext>
    )
  )
}
export default MenuListPopUp
